var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_790_1291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21363 17.4362H14.2615V21.1299H0V0H4.21363V17.4362Z",
    fill: "#0F2830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.129 3.69377H43.3518V9.17484H52.7109V12.8289H43.3518V21.1299H39.1382V0H54.0885V3.69377H54.129Z",
    fill: "#0F2830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8269 0V21.1299H57.6133V0H61.8269Z",
    fill: "#0F2830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9096 0H85.0828V21.1299H81.1933L72.2798 9.01597C71.429 7.90387 70.6997 6.79177 70.5376 6.39459L70.4566 6.43431C70.5782 6.8712 70.6592 8.14218 70.6592 9.53231V21.1299H66.4456V0H70.3351L79.2485 12.114C80.0993 13.2261 80.8286 14.3382 80.9907 14.7354L81.0717 14.6956C80.9502 14.2587 80.8691 12.9878 80.8691 11.5976V0H80.9096Z",
    fill: "#0F2830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0921 21.1299C20.1363 21.1299 15.3149 16.4035 15.3149 10.565C15.3149 4.72643 20.1363 0 26.0921 0C32.0479 0 36.8693 4.72643 36.8693 10.565C36.8693 16.4035 32.0074 21.1299 26.0921 21.1299ZM26.0921 4.13067C22.4862 4.13067 19.5286 7.03008 19.5286 10.565C19.5286 14.0999 22.4862 16.9993 26.0921 16.9993C29.698 16.9993 32.6556 14.0999 32.6556 10.565C32.6556 7.03008 29.698 4.13067 26.0921 4.13067Z",
    fill: "url(#paint0_linear_790_1291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9927 3.41574C33.9927 3.41574 33.9927 3.37603 33.9522 3.37603C33.1014 2.46251 30.4679 0.0397179 26.1327 0C21.757 0 19.1235 2.42279 18.2321 3.37603C18.2321 3.41574 18.1916 3.41574 18.1916 3.41574C17.4218 4.2101 16.8141 9.05569 17.6244 9.85005C18.0296 10.2472 18.3132 10.4061 18.5563 10.4061C19.1235 10.4061 19.4881 9.85005 19.5691 9.77061C19.6097 9.294 19.7717 8.53936 20.1769 7.745C20.42 7.22867 20.7846 6.67261 21.1898 6.27543L21.2708 6.196C21.4734 5.99741 23.094 4.17038 26.0922 4.13067C28.7257 4.13067 30.792 6.11656 30.954 6.27543L30.9946 6.31515C31.8049 7.10951 33.1419 7.10951 33.9927 6.31515C34.7625 5.52079 34.803 4.24982 33.9927 3.41574Z",
    fill: "url(#paint1_linear_790_1291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0203 21.1299C93.0645 21.1299 88.2432 16.4035 88.2432 10.565C88.2432 4.72644 93.105 0 99.0203 0C104.976 0 109.797 4.72644 109.797 10.565C109.797 16.4035 104.976 21.1299 99.0203 21.1299ZM99.0203 4.13067C95.4144 4.13067 92.4568 7.03008 92.4568 10.565C92.4568 14.0999 95.4144 16.9993 99.0203 16.9993C102.626 16.9993 105.584 14.0999 105.584 10.565C105.584 7.03008 102.626 4.13067 99.0203 4.13067Z",
    fill: "url(#paint2_linear_790_1291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.961 3.41574C106.961 3.41574 106.961 3.37603 106.921 3.37603C106.03 2.42279 103.396 0 99.0609 0C94.6852 0 92.0517 2.42279 91.1604 3.37603C91.1604 3.41574 91.1198 3.41574 91.1198 3.41574C90.35 4.2101 89.7423 9.05569 90.5526 9.85005C90.9578 10.2472 91.2414 10.4061 91.4845 10.4061C92.0517 10.4061 92.4163 9.85005 92.4974 9.77061C92.5379 9.294 92.7 8.53936 93.1051 7.745C93.3482 7.22867 93.7128 6.67261 94.118 6.27543L94.199 6.196C94.4016 5.99741 96.0222 4.17038 99.0204 4.13067C101.654 4.13067 103.72 6.11656 103.882 6.27543L103.923 6.31515C104.733 7.10951 106.07 7.10951 106.921 6.31515C107.731 5.52079 107.731 4.24982 106.961 3.41574Z",
    fill: "url(#paint3_linear_790_1291)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_790_1291",
    x1: 40.4242,
    y1: 14.127,
    x2: 5.62785,
    y2: 5.13822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0220619,
    stopColor: "#0F2830",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0604895,
    stopColor: "#0F2830",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4319,
    stopColor: "#0F2830",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5617,
    stopColor: "#0F2830",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6701,
    stopColor: "#0F2830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#0F2830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E5E6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_790_1291",
    x1: 17.2389,
    y1: 5.21056,
    x2: 34.5851,
    y2: 5.21056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.036892,
    stopColor: "#0F2830",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2386,
    stopColor: "#0F2830",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4387,
    stopColor: "#0F2830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#0F2830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_790_1291",
    x1: 113.371,
    y1: 14.127,
    x2: 78.5743,
    y2: 5.13822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0220619,
    stopColor: "#0F2830",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0604895,
    stopColor: "#0F2830",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4319,
    stopColor: "#0F2830",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5617,
    stopColor: "#0F2830",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6701,
    stopColor: "#0F2830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#0F2830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_790_1291",
    x1: 90.1853,
    y1: 5.21056,
    x2: 107.532,
    y2: 5.21056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.036892,
    stopColor: "#0F2830",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2386,
    stopColor: "#0F2830",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4387,
    stopColor: "#0F2830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9445,
    stopColor: "#0F2830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2830"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_790_1291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 21.1299,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.c6bc62d334bf1b5012081e20b45d5789.svg";